import { createModel } from 'xstate/lib/model';

import { initAuthBroadcastChannel } from './utils';

export const AuthModel = createModel(
  { authBroadcastChannel: initAuthBroadcastChannel() },
  {
    events: {
      LOGOUT: (csrfToken: string) => ({ csrfToken }),
      LOGIN: (csrfToken: string) => ({ csrfToken }),
      INIT_LOGGED_IN_SESSION: (csrfToken: string) => ({ csrfToken }),
      INIT_GUEST_SESSION: (csrfToken: string) => ({ csrfToken }),
      UPDATE_CSRF_TOKEN: (csrfToken: string) => ({ csrfToken }),
    },
  },
);
